module.exports = __webpack_public_path__ + "img/top-message.b72f6a5d.png";